/**
 * @hidden
 */
export function walkAndReplace(value, options, pointer = []) {
    if (options.beforeWalk) {
        value = options.beforeWalk(value, pointer);
    }
    if (Array.isArray(value)) {
        const newValue = [];
        for (let i = 0; i < value.length; i++) {
            let entryValue = value[i];
            entryValue = walkAndReplace(entryValue, options, pointer.concat(`${i}`));
            newValue.push(entryValue);
        }
        value = newValue;
    }
    else if (typeof value === 'object') {
        const newValue = {};
        const keys = Object.keys(value);
        for (const entryKey of keys) {
            let entryValue = value[entryKey];
            entryValue = walkAndReplace(entryValue, options, pointer.concat(entryKey));
            newValue[entryKey] = entryValue;
        }
        value = newValue;
    }
    if (options.afterWalk) {
        value = options.afterWalk(value, pointer);
    }
    return value;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSnNvbldhbGtlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvdXRpbHMvSnNvbldhbGtlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRQTs7R0FFRztBQUNILE1BQU0sVUFBVSxjQUFjLENBQzVCLEtBQVUsRUFDVixPQUE4QixFQUM5QixVQUFvQixFQUFFO0lBRXRCLElBQUksT0FBTyxDQUFDLFVBQVUsRUFBRTtRQUN0QixLQUFLLEdBQUcsT0FBTyxDQUFDLFVBQVUsQ0FBQyxLQUFLLEVBQUUsT0FBTyxDQUFDLENBQUM7S0FDNUM7SUFFRCxJQUFJLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLEVBQUU7UUFDeEIsTUFBTSxRQUFRLEdBQUcsRUFBRSxDQUFDO1FBQ3BCLEtBQUssSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxLQUFLLENBQUMsTUFBTSxFQUFFLENBQUMsRUFBRSxFQUFFO1lBQ3JDLElBQUksVUFBVSxHQUFHLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQztZQUMxQixVQUFVLEdBQUcsY0FBYyxDQUFDLFVBQVUsRUFBRSxPQUFPLEVBQUUsT0FBTyxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQztZQUN6RSxRQUFRLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxDQUFDO1NBQzNCO1FBQ0QsS0FBSyxHQUFHLFFBQVEsQ0FBQztLQUNsQjtTQUFNLElBQUksT0FBTyxLQUFLLEtBQUssUUFBUSxFQUFFO1FBQ3BDLE1BQU0sUUFBUSxHQUFHLEVBQUUsQ0FBQztRQUNwQixNQUFNLElBQUksR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQ2hDLEtBQUssTUFBTSxRQUFRLElBQUksSUFBSSxFQUFFO1lBQzNCLElBQUksVUFBVSxHQUFHLEtBQUssQ0FBQyxRQUFRLENBQUMsQ0FBQztZQUNqQyxVQUFVLEdBQUcsY0FBYyxDQUN6QixVQUFVLEVBQ1YsT0FBTyxFQUNQLE9BQU8sQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDLENBQ3pCLENBQUM7WUFDRixRQUFRLENBQUMsUUFBUSxDQUFDLEdBQUcsVUFBVSxDQUFDO1NBQ2pDO1FBQ0QsS0FBSyxHQUFHLFFBQVEsQ0FBQztLQUNsQjtJQUVELElBQUksT0FBTyxDQUFDLFNBQVMsRUFBRTtRQUNyQixLQUFLLEdBQUcsT0FBTyxDQUFDLFNBQVMsQ0FBQyxLQUFLLEVBQUUsT0FBTyxDQUFDLENBQUM7S0FDM0M7SUFFRCxPQUFPLEtBQUssQ0FBQztBQUNmLENBQUMifQ==